<template>
    <div class="">
                    <!-- <div class="row text-center q-px-sm"> -->
        <div class="row float-right" style="">
            <!-- og class = "q-mr-xs" -->
            <q-btn class="" v-if="ShowTopupButton" :label='$t("common.ClickToInvest")' text-color="white" @click="TopupButton()" :disable="DisableTopupButton" unelevated size="md" style="background-color: #ff6666" />
            <q-btn class="" v-if="ShowRedemptionButton" :label='$t("common.ClickToRedeem")' text-color="white" @click="RedemptionButton()" :disable="DisableRedemptionButton" unelevated size="md" style="background-color: #ff6666"/>
            <q-btn class="" v-if="ShowSwitchingButton" :label='$t("common.ClickToSwitch")' text-color="white" @click="SwitchingButton()" :disable="DisableSwitchingButton" unelevated size="md" style="background-color: #ff6666"/>
        </div>
    </div>
</template>

<script>
import store from '../store'; // only use for calling states
import { mapActions } from "vuex"; // only use for calling actions
export default {
    props: [
        'ShowTopupButton',
        'DisableTopupButton',
        'ShowRedemptionButton',
        'DisableRedemptionButton',
        'ShowSwitchingButton',
        'DisableSwitchingButton',
    ],
    components: {
    },
    data() {
        return {
        
        }
    },
    methods : {
        TopupButton(){
            this.$emit('TopupButton')
        },
        RedemptionButton(){
            this.$emit('RedemptionButton')
        },
        SwitchingButton(){
            this.$emit('SwitchingButton')
        }
    },
    mounted(){
        
    }
}
</script>
        